import {defineNuxtRouteMiddleware, navigateTo, obtainActiveLocale, useAuthUser} from "#imports";

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const user = useAuthUser()
  const activeLocale = obtainActiveLocale().code;

  if (!user.value)
    return navigateTo(`/${activeLocale}/admin/sign_in`)
})
